"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var PAGE_SIZE = 20;
var ProductQuery = new _immutable.Record({
  search: '',
  offset: 0,
  count: PAGE_SIZE,
  sorts: (0, _immutable.List)([(0, _immutable.Map)({
    property: 'createdate',
    order: 'DESC'
  })]),
  filterGroups: (0, _immutable.List)()
});
var _default = ProductQuery;
exports.default = _default;
module.exports = exports.default;